<template>
  <v-stepper v-model="step" elevation="0">
    <v-stepper-header elevation="0">
      <v-stepper-step :complete="step > 1" step="1">
        {{ $t("storyHub.publishing.wizard.reviewInformation") }}
      </v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step :complete="step > 2" step="2">
        {{ $t("storyHub.publishing.wizard.creditsAndSponsors") }}
      </v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step step="3">{{
        $t("storyHub.publishing.wizard.confirmation")
      }}</v-stepper-step>
    </v-stepper-header>

    <v-stepper-items elevation="0">
      <v-stepper-content step="1">
        <v-card
          class="mb-12 rounded-xl"
          color="grey lighten-1"
          min-height="200px"
        >
          <Overview ref="overview" @validStory="validStory = $event" />
        </v-card>
        <v-container fluid class="text-right">
          <v-row>
            <v-col cols=9 class="text-left"
              ><v-row
                ><v-col cols=auto
                  ><v-icon size="50" color="error" v-if="!validStory"
                    >mdi-alert-octagon</v-icon
                  ></v-col
                ><v-col cols=10
                  ><div v-if="!validStory"
                    class="error--text font-weight-bold"
                    v-html="
                      $t('storyHub.publishing.errors.missingRequiredItems')
                    " /></v-col
              ></v-row>
            </v-col>
            <v-spacer />
            <v-col cols="auto">
              <v-btn @click="back" color="accentElementBackground">
                {{ $t("forms.cancel") }}
              </v-btn>
            </v-col>
            <v-col cols="auto">
              <v-btn
                color="primary"
                @click="pushStep(2)"
                :disabled="!validStory"
              >
                {{ $t("forms.next") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-stepper-content>

      <v-stepper-content step="2">
        <v-container fluid class="text-left">
          <CreditsAndSponsors />
        </v-container>
        <v-container fluid class="text-right">
          <v-btn @click="back" color="accentElementBackground">
            {{ $t("forms.back") }}
          </v-btn>
          <v-btn color="primary" @click="pushStep(3)">
            {{ $t("forms.next") }}
          </v-btn>
        </v-container>
      </v-stepper-content>

      <v-stepper-content step="3">
        <PublishInfo v-model="publishable" :published="published" />
        <v-container fluid class="text-right">
          <v-btn @click="back" color="accentElementBackground">
            {{ $t("forms.back") }}
          </v-btn>
          <Publish :active="publishable" />
        </v-container>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>
<script>
import CreditsAndSponsors from "./CreditsAndSponsors";
import Overview from "./Overview";
import Publish from "./Publish";
import PublishInfo from "./PublishInfo";
import { mapGetters } from "vuex";
export default {
  components: {
    CreditsAndSponsors,
    Overview,
    Publish,
    PublishInfo,
  },
  computed: {
    ...mapGetters("story", ["getInProgress", "getSuccess"]),
  },
  props: {
    published: Boolean,
  },
  data() {
    return {
      step: this.getCurrentStep(),
      inProgress: false,
      publishable: false,
      validStory: true,
    };
  },
  watch: {
    "$route.hash"(newHash) {
      if (newHash != "") {
        this.step = newHash.substring(1, newHash.length);
      }
    },
    getInProgress(newValue, oldValue) {
      if (!newValue && oldValue && this.getSuccess) {
        this.pushStep(2);
      }
    },
  },
  methods: {
    getCurrentStep() {
      let hash = this.$route.hash;
      if (hash == "") {
        return 1;
      } else {
        return hash.substring(1, hash.length);
      }
    },
    back() {
      this.$router.back();
    },
    pushStep(step) {
      this.$router.push("#" + step);
    },
    saveOverview() {
      if (this.$refs.overview.validate()) {
        this.$refs.overview.saveStory();
      }
    },
  },
};
</script>
<style scoped>
button {
  margin: 0 1em;
}
button:last-child {
  margin: 0;
}
</style>